import { useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useTranslation } from 'react-i18next';

import { Search } from 'components/ui';
import useLoadDashboardPatients from './hooks/useLoadDashboardPatients';
import { careTeamMemberRouteTemplates } from 'routing/routeTemplates';


const PatientsSearchBar = ({ history }) => {
  const [searchPatients, setSearchPatients] = useState("")
  const [searchPatientsWithDelay] = useDebounce(searchPatients, 200)
  const { t } = useTranslation();
  const { patients, loadingGetPatients } = useLoadDashboardPatients(searchPatientsWithDelay, searchPatients)

  const searchResultOnClick = (patientId) => {
    history.push(
      `/patientRecord/${patientId}`,
      { from : {
        pathname: careTeamMemberRouteTemplates.dashboardPage,
        title: 'Dashboard',
      }}
    )
  };

  const handleEnter = (e) => {
    if (e.target.value === "") {
      setSearchPatients(null);
    } else {
      setSearchPatients(e.target.value)
    }
  }

  return (
    <Search
      isHome
      fullWidth
      placeholder={`${t('Search patient')}...`}
      style={{ margin: '24px auto' }}
      data-id="search-patient"
      onChange={(e) => handleEnter(e)}
      inputValue={searchPatientsWithDelay}
      loading={loadingGetPatients}
      items={patients}
      handleSelect={searchResultOnClick}
    />
  );
};

export default PatientsSearchBar;